<template>
    <section class="gz-modal-main-tmpl">
        <div class="gz-modal-main-tmpl__title">
            <span v-if="icon" :class="icon" style="margin-right: 10px"></span>
            <slot name="title"></slot>
        </div>
        <section class="gz-modal-main-tmpl__content" :class="{'gz-modal-main-tmpl__content_overflow' : overflow}">
            <slot name="content"></slot>
        </section>
        <section class="gz-modal-main-tmpl__block-controls">
            <slot name="actions"></slot>
        </section>
    </section>
</template>

<script>
export default {
    name: 'ModalMainTemplate',

    props: {
        icon: String,
        overflow: {
            type: Boolean,
            default: true
        }
    }
}
</script>